"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDistrictListPage = exports.generateDistrictWtf = exports.generateFullWtf = void 0;
const env = require("./environment");
const types_1 = require("./types");
const utils_1 = require("./utils");
const QRCode = require("qrcode");
const logger = console;
const generateFullWtf = (data, meetingType) => {
    if (meetingType !== types_1.MEETING_TYPE.ALL) {
        console.log('Filtering by ', meetingType);
        data = data.filter(d => d.types && d.types.includes(meetingType));
    }
    const pubDateEl = document.getElementById('publication-date');
    pubDateEl.textContent = new Date().toLocaleDateString('en-GB');
    let pages = 6;
    const docHeightCm = 29.7;
    const docPageNumHeightCm = env.IS_FIREFOX ? 2.5 : 2;
    const meetingsListEl = document.getElementsByClassName('meetings-raw')[0];
    (0, utils_1.sortMeetings)(data);
    data.sort((a, b) => {
        return ('' + a.region).localeCompare(b.region);
    });
    for (let i = 0; i < data.length; i++) {
        const mtg = data[i];
        let matches;
        let postcode;
        let city;
        if (!mtg)
            continue;
        if (i === 0 || mtg.region !== data[i - 1].region && mtg.region) {
            const regionHeaderEl = document.createElement('div');
            regionHeaderEl.className = 'region-header';
            regionHeaderEl.textContent = mtg.region;
            meetingsListEl.appendChild(regionHeaderEl);
        }
        if (!mtg.formatted_address) {
            logger.error('No address', i, mtg);
            continue;
        }
        const addressSplit = mtg.formatted_address.split(', ');
        if (addressSplit[addressSplit.length - 1] === 'UK' || addressSplit[addressSplit.length - 1] === 'United Kingdom') {
            addressSplit.splice(addressSplit.length - 1, 1);
        }
        for (const addrPart of addressSplit) {
            matches = utils_1.postcodeRegex.exec(addrPart);
            if (!matches || !matches.length) {
                matches = utils_1.postcodeAreaRegex.exec(addrPart);
                if (matches && matches.length) {
                    postcode = matches[0];
                    city = addrPart.substr(0, matches.index);
                }
            }
            else {
                postcode = matches[0];
                city = addrPart.substr(0, matches.index);
            }
            utils_1.postcodeRegex.lastIndex = 0;
            utils_1.postcodeAreaRegex.lastIndex = 0;
        }
        let postcodeArea = '';
        if (!postcode && !city) {
            logger.info('No city found', i, mtg.formatted_address);
            logger.info('Defaulting to ' + addressSplit[addressSplit.length - 1]);
            city = addressSplit[addressSplit.length - 1];
        }
        if (!postcode) {
            logger.error('No postcode match', i, mtg.formatted_address);
        }
        else {
            try {
                postcodeArea = postcode.split(' ')[0];
            }
            catch (err) {
                logger.error('Postcode split error', postcode);
                continue;
            }
        }
        const meetingEl = document.createElement('a');
        meetingEl.href = mtg.url;
        meetingEl.target = '_blank';
        meetingEl.className = 'meeting';
        const topEl = document.createElement('div');
        topEl.className = 'top';
        const datetimeEl = document.createElement('div');
        datetimeEl.className = 'datetime';
        let txt = (0, utils_1.numToDay)(parseInt(mtg.day, 10)) + ' ' + mtg.time;
        if (mtg.end_time && mtg.end_time !== '')
            txt += ' – ' + mtg.end_time;
        datetimeEl.textContent = txt;
        const postcodeEl = document.createElement('div');
        postcodeEl.className = 'postcode';
        postcodeEl.textContent = city + ' ' + postcodeArea;
        topEl.appendChild(datetimeEl);
        topEl.appendChild(postcodeEl);
        meetingEl.appendChild(topEl);
        const bottomEl = document.createElement('div');
        bottomEl.className = 'bottom';
        const addressEl = document.createElement('span');
        addressEl.className = 'address';
        txt = '';
        if (mtg.name !== '') {
            txt += "'" + mtg.name + "'";
            txt += ' ';
        }
        if (meetingType === types_1.MEETING_TYPE.ONL) {
            txt += `<a target="_blank" href="${mtg.conference_url}">${mtg.conference_url}</a>`;
        }
        else {
            if (mtg.location !== '') {
                txt += mtg.location + ', ';
            }
        }
        if (meetingType !== types_1.MEETING_TYPE.ONL) {
            for (let x = 0; x < addressSplit.length; x++) {
                if (x === addressSplit.length - 1) {
                    txt += '<span class="address-part postcode">' + addressSplit[x];
                }
                else {
                    txt += '<span class="address-part">' + addressSplit[x];
                }
                if (x !== addressSplit.length - 1)
                    txt += ', ';
                txt += '</span>';
            }
        }
        addressEl.innerHTML = txt;
        const travelEl = document.createElement('span');
        travelEl.className = 'travel';
        bottomEl.appendChild(addressEl);
        bottomEl.appendChild(travelEl);
        meetingEl.appendChild(bottomEl);
        meetingsListEl.appendChild(meetingEl);
    }
    const pxPerCm = (0, utils_1.px2cm)();
    const meetingsPagesEl = document.getElementsByClassName('meetings-pages')[0];
    const children = meetingsListEl.children;
    let currHeightPx = 0;
    let elementsInPage = [];
    let lastPage = pages;
    let lastRegion;
    for (let i = 0; i < children.length; i++) {
        const el = children[i];
        let newPage = false;
        if (pages !== lastPage) {
            newPage = true;
            lastPage = pages;
        }
        const isHeader = el.classList.contains('region-header');
        if (newPage) {
            if (!elementsInPage[0].classList.contains('region-header')) {
                const regionHeaderEl = document.createElement('div');
                regionHeaderEl.className = 'region-header';
                regionHeaderEl.textContent = lastRegion.indexOf('(Cont.)') >= 0 ? lastRegion : lastRegion + ' (Cont.)';
                elementsInPage.unshift(regionHeaderEl);
            }
        }
        if (isHeader) {
            lastRegion = el.textContent;
        }
        const rect = el.getBoundingClientRect();
        if ((currHeightPx + rect.height) / pxPerCm >= (docHeightCm - docPageNumHeightCm)) {
            const carryOver = [];
            const pageEl = document.createElement('div');
            pageEl.className = 'page';
            let popped = elementsInPage.shift();
            while (popped !== undefined) {
                if (!elementsInPage.length && popped.classList.contains('region-header')) {
                    carryOver.push(popped);
                }
                else {
                    pageEl.appendChild(popped);
                }
                popped = elementsInPage.shift();
            }
            carryOver.push(el.cloneNode(true));
            const pageNumEl = document.createElement('div');
            pageNumEl.className = 'page-num';
            pageNumEl.textContent = pages.toString();
            pageEl.appendChild(pageNumEl);
            meetingsPagesEl.appendChild(pageEl);
            if (elementsInPage.length > 0) {
                logger.error('Elements left!', elementsInPage);
                break;
            }
            elementsInPage = carryOver;
            currHeightPx = 0;
            for (let k = 0; k < elementsInPage.length; k++) {
                const _el = elementsInPage[k].cloneNode(true);
                document.body.appendChild(_el);
                currHeightPx += el.getBoundingClientRect().height;
                document.body.removeChild(_el);
            }
            pages++;
        }
        else {
            elementsInPage.push(el.cloneNode(true));
            currHeightPx += rect.height;
        }
    }
    document.body.removeChild(meetingsListEl);
    const pagesAfterMeetings = document.body.getElementsByClassName('page post-wtf');
    for (let i = 0; i < pagesAfterMeetings.length; i++) {
        const page = pagesAfterMeetings[i];
        (0, utils_1.addNumToPage)(page, pages++);
        page.classList.add('processed');
    }
    const mod = (pages - 1) % 4;
    let extraPages = !!!mod ? 0 : 4 - mod;
    const notePage = document.body.getElementsByClassName('page notes')[0];
    while (!!extraPages) {
        const clone = notePage.cloneNode(true);
        clone.classList.remove('hidden');
        clone.classList.add('processed');
        document.body.appendChild(clone);
        (0, utils_1.addNumToPage)(clone, pages++);
        extraPages--;
    }
    notePage.remove();
};
exports.generateFullWtf = generateFullWtf;
const generateDistrictWtf = (data, district, subDistrict = undefined, showQrCode = false, hideDate = false, customTitle = undefined, outwardCodesFilter = []) => {
    const docHeightCm = 19;
    const meetingsListEl = document.getElementsByClassName('meetings-raw')[0];
    const districtReplacements = document.getElementsByClassName('district');
    for (let i = 0; i < districtReplacements.length; i++) {
        districtReplacements.item(i).textContent = customTitle ? customTitle : subDistrict ? subDistrict : district;
    }
    data = data.map((datum) => (Object.assign(Object.assign({}, datum), { types: datum.types ? datum.types : [] })));
    data = (0, utils_1.filterMeetingsByDistrict)(data, district, subDistrict);
    data = (0, utils_1.filterMeetingsByOutwardCodes)(data, outwardCodesFilter);
    data = data.filter((meeting) => {
        return !meeting.types.includes('TC') || meeting.types.includes('ONL');
    });
    const latestUpdatedMeetingDate = data.length ?
        new Date(data.reduce((prev, current) => {
            if (!prev || new Date(current.updated.replace(" ", "T") + "Z") > new Date(prev.updated.replace(" ", "T") + "Z"))
                return current;
            return prev;
        }).updated.replace(" ", "T") + "Z")
        : new Date();
    const pubDateEl = document.getElementById('publication-date');
    pubDateEl.textContent = latestUpdatedMeetingDate.toLocaleDateString('en-GB');
    if (hideDate) {
        pubDateEl.classList.add('hidden');
        document.getElementsByClassName('publication-date-desc')[0].classList.add('hidden');
    }
    if (showQrCode) {
        const logo = document.getElementsByClassName('logo')[0];
        logo.classList.add("with-qrcode");
        const qrCodeCanvasEl = document.getElementById('qr-code');
        qrCodeCanvasEl.classList.remove('hidden');
        const meetingUrl = `https://meetings.cocaineanonymous.org.uk/meetings/?tsml-day=any&tsml-district=${district}`;
        QRCode.toCanvas(qrCodeCanvasEl, meetingUrl);
    }
    (0, utils_1.sortMeetings)(data);
    for (let i = 0; i < data.length; i++) {
        const mtg = data[i];
        let matches;
        let postcode;
        let city;
        if (!mtg)
            continue;
        if (i === 0 || (mtg.day !== null && mtg.day !== undefined && mtg.day !== data[i - 1].day)) {
            const dayHeaderEl = document.createElement('div');
            dayHeaderEl.className = 'day-header';
            dayHeaderEl.textContent = (0, utils_1.numToDay)(parseInt(mtg.day, 10));
            meetingsListEl.appendChild(dayHeaderEl);
        }
        if (!mtg.formatted_address) {
            logger.error('No address', i, mtg);
            continue;
        }
        const addressSplit = mtg.formatted_address.split(', ');
        if (addressSplit[addressSplit.length - 1] === 'UK' || addressSplit[addressSplit.length - 1] === 'United Kingdom') {
            addressSplit.splice(addressSplit.length - 1, 1);
        }
        for (const addrPart of addressSplit) {
            matches = utils_1.postcodeRegex.exec(addrPart);
            if (!matches || !matches.length) {
                matches = utils_1.postcodeAreaRegex.exec(addrPart);
                if (matches && matches.length) {
                    postcode = matches[0];
                    city = addrPart.substr(0, matches.index);
                }
            }
            else {
                postcode = matches[0];
                city = addrPart.substr(0, matches.index);
            }
            utils_1.postcodeRegex.lastIndex = 0;
            utils_1.postcodeAreaRegex.lastIndex = 0;
        }
        const meetingEl = document.createElement('a');
        meetingEl.href = mtg.url;
        meetingEl.target = '_blank';
        meetingEl.className = 'meeting';
        const topEl = document.createElement('div');
        topEl.className = 'top';
        const datetimeEl = document.createElement('div');
        datetimeEl.className = 'datetime';
        let txt = '<b>' + mtg.time;
        if (mtg.end_time && mtg.end_time !== '')
            txt += ' – ' + mtg.end_time;
        txt += '</b> ' + mtg.name;
        const allowedCategories = [
            'O',
            'W',
            'M',
            'X',
        ];
        let categories = mtg.types.filter(cat => allowedCategories.includes(cat));
        if ((0, utils_1.doesMeetingSupportChitSystem)(mtg)) {
            categories.push('CH');
        }
        const categoryMap = {
            CH: 'Chit',
            M: 'Men',
            O: 'Open',
            W: 'Women',
            X: '♿',
        };
        categories = categories.map(cat => categoryMap[cat] ? categoryMap[cat] : cat);
        if (categories.length) {
            txt += ` <b>(${categories.join(', ')}</b>)`;
        }
        datetimeEl.innerHTML = txt.slice();
        topEl.appendChild(datetimeEl);
        meetingEl.appendChild(topEl);
        txt = '';
        const bottomEl = document.createElement('div');
        bottomEl.className = 'bottom';
        const addressEl = document.createElement('span');
        addressEl.className = 'address';
        if (mtg.location !== '') {
            if (mtg.attendance_option == "online") {
                txt = city ? city : addressSplit[addressSplit.length - 1] ? addressSplit[addressSplit.length - 1] : '';
                txt += ' (Online)';
            }
            else if (mtg.types.includes('TC')) {
                txt = city ? city : addressSplit[addressSplit.length - 1] ? addressSplit[addressSplit.length - 1] : '';
                txt += ' (Meeting temporarily closed)';
            }
            else {
                if (mtg.attendance_option == "hybrid") {
                    txt += ' (In-person & Online) ';
                }
                txt += mtg.location + ', ';
                for (let x = 0; x < addressSplit.length; x++) {
                    if (x === addressSplit.length - 1) {
                        txt += '<span class="address-part postcode">' + addressSplit[x];
                    }
                    else {
                        txt += '<span class="address-part">' + addressSplit[x];
                    }
                    if (x !== addressSplit.length - 1)
                        txt += ', ';
                    txt += '</span>';
                }
            }
            addressEl.innerHTML = txt.slice();
            bottomEl.appendChild(addressEl);
        }
        txt = '';
        if (mtg.conference_url) {
            const onlineEl = document.createElement('span');
            onlineEl.className = 'online';
            let onlineMeetingId = (0, utils_1.extractOnlineMeetingIdFromURL)(mtg.conference_url);
            if (!onlineMeetingId) {
                logger.warn(`Unable to extract meeting ID from url: ${mtg.conference_url}, meeting ID: ${mtg.id}`);
                matches = utils_1.onlineMeetingIdRegex.exec(mtg.notes);
                if (!matches || !matches.length) {
                    logger.error(`No online meeting ID found in notes for meeting: ${mtg.id}`);
                }
                else {
                    onlineMeetingId = matches[1];
                }
            }
            else {
                onlineMeetingId = (0, utils_1.formatMeetingID)(onlineMeetingId, (0, utils_1.detectOnlineMeetingTypeFromURL)(mtg.conference_url));
            }
            let onlineMeetingPassword = null;
            if (onlineMeetingId) {
                matches = utils_1.onlineMeetingPasswordRegex.exec(mtg.notes);
                if (!matches || !matches.length) {
                    logger.warn(`No online meeting password found in notes for meeting: ${mtg.id}`);
                    if ((0, utils_1.extractOnlineMeetingPasswordFromURL)(mtg.conference_url)) {
                        onlineMeetingPassword = 'Unknown';
                    }
                }
                else {
                    onlineMeetingPassword = matches[2];
                }
            }
            const onlineMeetingType = (0, utils_1.detectOnlineMeetingTypeFromURL)(mtg.conference_url);
            let onlineMeetingText;
            if (onlineMeetingId) {
                onlineMeetingText = `${onlineMeetingType} ID: ${onlineMeetingId}`;
                if (onlineMeetingPassword) {
                    onlineMeetingText += ` / Password: ${onlineMeetingPassword}`;
                }
            }
            else {
                onlineMeetingText = mtg.conference_url;
            }
            txt += `<a target="_blank" href="${mtg.conference_url}">${onlineMeetingText}</a>`;
            onlineEl.innerHTML = txt;
            bottomEl.appendChild(onlineEl);
        }
        meetingEl.appendChild(bottomEl);
        meetingsListEl.appendChild(meetingEl);
    }
    const pxPerCm = (0, utils_1.px2cm)();
    const meetingsPagesEl = document.getElementsByClassName('meetings-pages')[0];
    let sourceElements = Array.prototype.slice.call(meetingsListEl.children);
    const elementsInSection = [];
    let currHeightPx = 0;
    let sectionCount = 0;
    let page = document.createElement('div');
    page.className = 'page';
    document.body.appendChild(page);
    let el = sourceElements.shift();
    while (el !== undefined) {
        const rect = el.getBoundingClientRect();
        if (((currHeightPx + rect.height) / pxPerCm >= docHeightCm)) {
            const carryOver = [];
            const sectionEl = document.createElement('div');
            sectionEl.className = 'page-third';
            page.appendChild(sectionEl);
            sectionCount++;
            let popped = elementsInSection.shift();
            while (popped !== undefined) {
                if (!elementsInSection.length && popped.classList.contains('day-header')) {
                    carryOver.push(popped);
                }
                else {
                    sectionEl.appendChild(popped);
                }
                popped = elementsInSection.shift();
            }
            sourceElements = [
                ...carryOver,
                el,
                ...sourceElements,
            ];
            currHeightPx = 0;
            if (sectionCount % 3 === 0) {
                logger.debug('Creating new page');
                page = document.createElement('div');
                page.className = 'page';
                document.body.appendChild(page);
            }
        }
        else if (!sourceElements.length) {
            const sectionEl = document.createElement('div');
            sectionEl.className = 'page-third';
            page.appendChild(sectionEl);
            sectionCount++;
            elementsInSection.push(el.cloneNode(true));
            elementsInSection.forEach((elToAdd) => {
                sectionEl.appendChild(elToAdd);
            });
            if (sectionCount % 3 === 0) {
                logger.debug('Creating new page');
                page = document.createElement('div');
                page.className = 'page';
                document.body.appendChild(page);
            }
        }
        else {
            elementsInSection.push(el.cloneNode(true));
            currHeightPx += rect.height;
        }
        el = sourceElements.shift();
    }
    document.body.removeChild(document.getElementsByClassName('dummy-page')[0]);
    document.body.removeChild(meetingsPagesEl);
    logger.info(`Section count: ${sectionCount}`);
    logger.info(`Adding ${2 - (sectionCount % 3)} notes pages`);
    for (let i = 0; i < 2 - (sectionCount % 3); i++) {
        const notesEl = document.getElementsByClassName('page-third notes')[0].cloneNode(true);
        notesEl.classList.remove('hidden');
        page.appendChild(notesEl);
    }
    const frontPage = document.getElementsByClassName('frontpage')[0];
    page.appendChild(frontPage);
    frontPage.classList.remove('hidden');
};
exports.generateDistrictWtf = generateDistrictWtf;
const generateDistrictListPage = (meetings) => {
    const districts = {};
    for (const meeting of meetings) {
        if (meeting.district === undefined) {
            logger.error(`Meeting with undefined district: ${meeting.id}`);
        }
        if (meeting.district == 'Unaffiliated')
            continue;
        if (!districts[meeting.district]) {
            districts[meeting.district] = [];
        }
        if (meeting.sub_district && !districts[meeting.district].includes(meeting.sub_district)) {
            districts[meeting.district].push(meeting.sub_district);
        }
    }
    const dummyPage = document.getElementsByClassName('dummy-page')[0];
    dummyPage.classList.add('hidden');
    const linkPage = document.createElement('div');
    linkPage.classList.add('link-page');
    document.body.appendChild(linkPage);
    const title = document.createElement('h1');
    title.textContent = 'To autogenerate your district Where to find, please click on a link below';
    linkPage.appendChild(title);
    for (const districtKey of Object.keys(districts).sort()) {
        const districtEl = document.createElement('a');
        districtEl.href = window.encodeURI(`${window.location}?district=${districtKey}`);
        districtEl.textContent = districtKey;
        linkPage.appendChild(districtEl);
        for (const subDistrict of districts[districtKey].sort()) {
            const districtEl = document.createElement('a');
            districtEl.href = window.encodeURI(`${window.location}?district=${districtKey}&subDistrict=${subDistrict}`);
            districtEl.textContent = `${districtKey} > ${subDistrict}`;
            linkPage.appendChild(districtEl);
        }
    }
};
exports.generateDistrictListPage = generateDistrictListPage;
